import { TallyLedgerOption } from 'shared/models';

/**
 * Which Sundry group a supplier's Tally ledger is kept under. Most suppliers are
 * creditors; a party that is also a customer is often kept under debtors.
 */
export type TallyLedgerSide = 'Creditors' | 'Debtors';

export const DEFAULT_TALLY_LEDGER_SIDE: TallyLedgerSide = 'Creditors';

/**
 * The side the already-linked ledger sits on, or null when the list does not say
 * (ledger not in it, no name, or the server gave no side for it).
 */
export function sideForLinkedLedger(
  options: TallyLedgerOption[],
  ledgerName: string | null | undefined
): TallyLedgerSide | null {
  const wanted = ledgerName?.trim().toLowerCase();
  if (!wanted) return null;
  // Tally ledger names are matched ignoring case and surrounding spaces, as the backend does.
  const side = options.find(o => o.LedgerName?.trim().toLowerCase() === wanted)?.PartySide;
  return side === 'Creditors' || side === 'Debtors' ? side : null;
}
